module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mainContent"
    }
  }, [_c('div', {
    staticClass: "t2 png"
  }), _vm._v(" "), _c('div', {
    staticClass: "png",
    attrs: {
      "id": "divBox"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center",
      "line-height": "30px",
      "border-bottom": "1px solid #BABABA"
    }
  }, [_vm._v("众安科技服务条款")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("欢迎阅读")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安信息技术服务有限公司（以下简称“众安科技”）")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("数据服务条款协议(下称“本协议”)。本协议阐述之条款和条件适用于您使用")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("所提供的各种工具和服务(下称“服务”)。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("1. 接受条款")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("以任何方式进入")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("即表示您同意自己已经与")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("订立本协议，且您将受本协议的条款和条件(“条款”) 约束。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("可随时自行全权决定更改“条款”。您应在第一次登录后仔细阅读修订后的“条款”，并有权选择停止继续使用“服务”；一旦您继续使用“服务”，则表示您已接受经修订的“条款”，当您与")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("发生争议时，应以最新的服务协议为准。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。除非经")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("的授权高层管理人员签订书面协议，本协议不得另行作出修订。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("2. 谁可使用")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("“服务”仅供能够根据相关法律订立具有法律约束力的合约的个人或公司使用。因此，您的年龄必须在十八周岁或以上，才可使用本公司服务。如不符合本项条件，请勿使用“服务”。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("可随时自行全权决定拒绝向任何人士提供“服务”。“服务”不会提供给被暂时或永久中止资格的")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("会员。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("3. 收费")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("本公司保留在根据第1条通知您后，收取“服务”费用的权利。您因进行交易、向本公司获取有偿服务或接触本公司服务器而发生的所有应纳税赋，以及相关硬件、软件、通讯、网络服务及其他方面的费用均由您自行承担。本公司保留在无须发出书面通知，仅在")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("公示的情况下，暂时或永久地更改或停止部分或全部“服务”的权利。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("4. 您的资料和供买卖的物品")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("“您的资料”包括您在注册、交易或列举物品过程中、在任何公开信息场合或通过任何电子邮件形式，向本公司或其他用户提供的任何资料，包括数据、文本、软件、音乐、声响、照片、图画、影像、词句或其他材料。您应对“您的资料”负全部责任，而本公司仅作为您在网上发布和刊登“您的资料”的被动渠道。但是，倘若本公司认为“您的资料”可能使本公司承担任何法律或道义上的责任，或可能使本公司 (全部或部分地) 失去本公司的互联网服务供应商或其他供应商的服务，或您未在")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("规定的期限内登录或再次登录网站，则本公司可自行全权决定对“您的资料”采取本公司认为必要或适当的任何行动，包括但不限于删除该类资料。您特此保证，您对提交给")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("的“您的资料”拥有全部权利，包括全部版权。您确认，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("没有责任去认定或决定您提交给本公司的资料哪些是应当受到保护的，对享有“服务”的其他用户使用“您的资料”，本公司也不必负责。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("4.1 注册义务")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("如您在")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("注册，您同意：(a) 根据会员注册页面所刊载的会员资料表格的要求，提供关于您或贵公司的真实、准确、完整和反映当前情况的资料；(b) 维持并及时更新会员资料，使其保持真实、准确、完整和反映当前情况。倘若您提供任何不真实、不准确、不完整或不能反映当前情况的资料，或")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("有权暂停或终止您的注册身份及资料，并拒绝您在目前或将来对“服务”(或其任何部份) 以任何形式使用。如您代表一家公司或其他法律主体在本公司登记，则您声明和保证，您有权使该公司或其他法律主体受本协议“条款”约束。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("4.2 会员注册名、密码和保密")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("在登记过程中，您将选择会员注册名和密码。您须自行负责对您的会员注册名和密码保密，且须对您在会员注册名和密码下发生的所有活动承担责任。您同意：(a) 如发现任何人未经授权使用您的会员注册名或密码，或发生违反保密规定的任何其他情况，您会立即通知")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("；及 (b) 确保您在每个上网时段结束时，以正确步骤离开网站。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("4.3 关于您的资料的规则")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt",
      "text-align": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("您同意，“您的资料”和您供在众安科技上交易的任何“物品”（泛指一切可供依法交易的、有形的或无形的、以各种形态存在的某种具体的物品，或某种权利或利益，或某种票据或证券，或某种服务或行为。本协议中“物品”一词均含此义）")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-left": "36.0000pt",
      "text-indent": "-18.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "10.0000pt"
    }
  }, [_c('span', [_vm._v("·"), _c('span', [_vm._v(" ")])])]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("a. 不会有欺诈成份，与售卖伪造或盗窃无涉。")]), _c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5000pt"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-left": "36.0000pt",
      "text-indent": "-18.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "10.0000pt"
    }
  }, [_c('span', [_vm._v("·"), _c('span', [_vm._v(" ")])])]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("b. 不会侵犯任何第三者对该物品享有的物权，或版权、专利、商标、商业秘密或其他知识产权，或隐私权、名誉权。")]), _c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5000pt"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-left": "36.0000pt",
      "text-indent": "-18.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "10.0000pt"
    }
  }, [_c('span', [_vm._v("·"), _c('span', [_vm._v(" ")])])]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("c. 不会违反任何法律、法规、条例或规章 (包括但不限于关于规范出口管理、贸易配额、保护消费者、不正当竞争或虚假广告的法律、法规、条例或规章)。")]), _c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5000pt"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-left": "36.0000pt",
      "text-indent": "-18.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "10.0000pt"
    }
  }, [_c('span', [_vm._v("·"), _c('span', [_vm._v(" ")])])]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("d. 不会含有诽谤（包括商业诽谤）、非法恐吓或非法骚扰的内容。")]), _c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5000pt"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-left": "36.0000pt",
      "text-indent": "-18.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "10.0000pt"
    }
  }, [_c('span', [_vm._v("·"), _c('span', [_vm._v(" ")])])]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("e. 不会含有淫秽、或包含任何儿童色情内容。")]), _c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5000pt"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-left": "36.0000pt",
      "text-indent": "-18.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "10.0000pt"
    }
  }, [_c('span', [_vm._v("·"), _c('span', [_vm._v(" ")])])]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("f. 不会含有蓄意毁坏、恶意干扰、秘密地截取或侵占任何系统、数据或个人资料的任何病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他电脑程序。")]), _c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5000pt"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-left": "36.0000pt",
      "text-indent": "-18.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "10.0000pt"
    }
  }, [_c('span', [_vm._v("·"), _c('span', [_vm._v(" ")])])]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("g. 不会直接或间接与下述各项货物或服务连接，或包含对下述各项货物或服务的描述：(i) 本协议项下禁止的货物或服务；或 (ii) 您无权连接或包含的货物或服务。此外，您同意不会：(h) 在与任何连锁信件、大量胡乱邮寄的电子邮件、滥发电子邮件或任何复制或多余的信息有关的方面使用“服务”；(i) 未经其他人士同意，利用“服务”收集其他人士的电子邮件地址及其他资料；或 (j) 利用“服务”制作虚假的电子邮件地址，或以其他形式试图在发送人的身份或信息的来源方面误导其他人士。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Calibri",
      "font-size": "10.5000pt"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("4.4 被禁止物品")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("您不得在本公司网站公布或通过本公司网站买卖：(a) 可能使本公司违反任何相关法律、法规、条例或规章的任何物品；或 (b) ")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("认为应禁止或不适合通过本网站买卖的任何物品。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("5. 您授予本公司的许可使用权")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("您授予本公司独家的、全球通用的、永久的、免费的许可使用权利 (并有权在多个层面对该权利进行再授权)，使本公司有权(全部或部份地) 使用、复制、修订、改写、发布、翻译、分发、执行和展示\"您的资料\"或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将\"您的资料\"纳入其他作品内。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("6. 隐私")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("尽管有第6条所规定的许可使用权，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("将仅根据本公司的隐私声明使用“您的资料”。本公司隐私声明的全部条款属于本协议的一部份，因此，您必须仔细阅读。请注意，您一旦自愿地在")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("交易地点披露“您的资料”，该等资料即可能被其他人士获取和使用。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("7. 终止或访问限制")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("您同意，在")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("未向您收费的情况下，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("可自行全权决定以任何理由 (包括但不限于")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("认为您已违反本协议的字面意义和精神，或您以不符合本协议的字面意义和精神的方式行事，或您在超过90天的时间内未以您的账号及密码登录网站) 终止您的“服务”密码、账户 (或其任何部份) 或您对“服务”的使用，并删除和丢弃您在使用“服务”中提交的 “您的资料”。您同意，在")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("向您收费的情况下，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("应基于合理的怀疑且经电子邮件通知的情况下实施上述终止服务的行为。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("同时可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供“服务”或其任何部份。您同意，根据本协议的任何规定终止您使用“服务”之措施可在不发出事先通知的情况下实施，并承认和同意，")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("可立即使您的账户无效，或撤销您的账户以及在您的账户内的所有相关资料和档案，和/或禁止您进一步接入该等档案或“服务”。账号终止后，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("没有义务为您保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，您同意，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("不会就终止您接入“服务”而对您或任何第三者承担任何责任。第9、10、11和19各条应在本协议终止后继续有效。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("8. 违反规则会有什么后果")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("在不限制其他补救措施的前提下，发生下述任一情况，本公司可立即发出警告，暂时中止、永久中止或终止您的会员资格，删除您的任何现有数据信息，以及您在网站上展示的任何其他资料：(i) 您违反本协议；(ii) 本公司无法核实或鉴定您向本公司提供的任何资料；或 (iii) 本公司相信您的行为可能会使您、本公司用户或通过本公司或本公司网站提供服务的第三者服务供应商发生任何法律责任。在不限制任何其他补救措施的前提下，倘若发现您从事涉及本公司网站的诈骗活动，")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("可暂停或终止您的账户。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("9. 服务“按现状”提供")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("本公司会尽一切努力使您在使用")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("的过程中得到乐趣。遗憾的是，本公司不能随时预见到任何技术上的问题或其他困难。该等困难可能会导致数据损失或其他服务中断。为此，您明确理解和同意，您使用“服务”的风险由您自行承担。“服务”以“按现状”和“按可得到”的基础提供。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("明确声明不作出任何种类的所有明示或暗示的保证，包括但不限于关于适销性、适用于某一特定用途和无侵权行为等方面的保证。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("对下述内容不作保证：(i)“服务”会符合您的要求；(ii)“服务”不会中断，且适时、安全和不带任何错误；(iii) 通过使用“服务”而可能获取的结果将是准确或可信赖的；及 (iv) 您通过“服务”而购买或获取的任何产品、服务、资料或其他材料的质量将符合您的预期。通过使用“服务”而下载或以其他形式获取任何材料是由您自行全权决定进行的，且与此有关的风险由您自行承担，对于因您下载任何该等材料而发生的您的电脑系统的任何损毁或任何数据损失，您将自行承担责任。您从")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("或通过或从“服务”获取的任何口头或书面意见或资料，均不产生未在本协议内明确载明的任何保证。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("10. 责任范围")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("您明确理解和同意，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("不对因下述任一情况而发生的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿 (无论")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("是否已被告知该等损害赔偿的可能性)：(i) 使用或未能使用“服务”；(ii) 因通过或从“服务”购买或获取任何货物、样品、数据、资料或服务，或通过或从“服务”接收任何信息或缔结任何交易所产生的获取替代货物和服务的费用；(iii) 未经批准接入或更改您的传输资料或数据；(iv) 任何第三者对“服务”的声明或关于“服务”的行为；或 (v) 因任何原因而引起的与“服务”有关的任何其他事宜，包括疏忽。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("11. 赔偿")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("您同意，因您违反本协议或经在此提及而纳入本协议的其他文件，或因您违反了法律或侵害了第三方的权利，而使第三方对")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("及其子公司、分公司、董事、职员、代理人提出索赔要求（包括司法费用和其他专业人士的费用），您必须赔偿给")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("及其分公司、董事、职员、代理人，使其等免遭损失。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("12. 遵守法律")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("您应遵守与您使用“服务”的所有相关的法律、法规、条例和规章。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("13. 广告和金融服务")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("您与在“服务”上或通过“服务”物色的刊登广告人士通讯或进行业务往来或参与其推广活动，包括就相关货物或服务付款和交付相关货物或服务，以及与该等业务往来相关的任何其他条款、条件、保证或声明，仅限于在您和该刊登广告人士之间发生。您同意，对于因任何该等业务往来或因在“服务”上出现该等刊登广告人士而发生的任何种类的任何损失或损毁，")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("无需负责或承担任何责任。您如打算通过“服务”创设或参与与任何公司、股票行情、投资或证券有关的任何服务，或通过“服务”收取或要求与任何公司、股票行情、投资或证券有关的任何新闻信息、警戒性信息或其他资料，敬请注意，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("不会就通过“服务”传送的任何该等资料的准确性、有用性或可用性、可获利性负责或承担任何责任，且不会对根据该等资料而作出的任何交易或投资决策负责或承担任何责任。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("14. 链接")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("“服务”或第三者均可提供与其他互联网网站或资源的链接。由于")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("并不控制该等网站和资源，您承认并同意，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("并不对该等外在网站或资源的可用性负责，且不认可该等网站或资源上或可从该等网站或资源获取的任何内容、宣传、产品、服务或其他材料，也不对其等负责或承担任何责任。您进一步承认和同意，对于任何因使用或信赖从此类网站或资源上获取的此类内容、宣传、产品、服务或其他材料而造成（或声称造成）的任何直接或间接损失，")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("均不承担责任。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("15. 通知")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("除非另有明确规定，任何通知应以电子邮件形式发送，或 (就您而言) 发送到您在登记过程中向")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("提供的电子邮件地址，或有关方指明的该等其他地址。在电子邮件发出二十四 (24) 小时后，通知应被视为已送达，除非发送人被告知相关电子邮件地址已作废。或者，本公司可通过邮资预付挂号邮件并要求回执的方式，将通知发到您在登记过程中向")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("提供的地址。在该情况下，在付邮当日三 (3) 天后通知被视为已送达。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("16. 不可抗力")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("对于因本公司合理控制范围以外的原因，包括但不限于自然灾害、罢工或骚乱、物质短缺或定量配给、暴动、战争行为、政府行为、通讯或其他设施故障或严重伤亡事故等，致使本公司延迟或未能履约的，")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("不对您承担任何责任。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("17. 转让")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("转让本协议无需经您同意。")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("18. 其他规定")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("本协议取代您和")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("众安科技")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("先前就相同事项订立的任何书面或口头协议。本协议各方面应受中华人民共和国大陆地区法律的管辖。倘若本协议任何规定被裁定为无效或不可强制执行，该项规定应被撤销，而其余规定应予执行。条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。本公司未就您或其他人士的某项违约行为采取行动，并不表明本公司撤回就任何继后或类似的违约事件采取行动的权利。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("19. 诉讼")])]), _c('b', [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "bold",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-left": "0.0000pt",
      "text-indent": "0.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("因本协议或本公司服务所引起或与其有关的任何争议应向")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("上海市黄浦区")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  }, [_vm._v("人民法院提起诉讼，并以中华人民共和国法律为管辖法律。")]), _c('span', {
    staticStyle: {
      "font-family": "宋体",
      "color": "#000000",
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "14px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "b2 png"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33180cbf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/zakj.vue
// module id = 195
// module chunks = 0